import { createModifiedOnColDef } from '../../../../../components/shared-columns/modified-on/modified-on';
import type { FirmInvestorContactsGridItemFragment } from '../graphql/__generated__';
import { editActionColDef } from './edit-action';
import { investorEmployeeEmailColDef } from './email';
import { investorEmployeeNameColDef } from './employee-name';
import { investorEmployeeKeyColDef } from './investor-employee-key';
import { sourceColDef } from './source';
import { statusColDef } from './status';
import { titlesColDef } from './titles';

export const firmsInvestorContactsGridColumns = [
  investorEmployeeKeyColDef,
  investorEmployeeNameColDef,
  investorEmployeeEmailColDef,
  titlesColDef,
  sourceColDef,
  createModifiedOnColDef<FirmInvestorContactsGridItemFragment>('modifiedOn'),
  statusColDef,
  editActionColDef,
];
